<div class="page">
    <ng-container *ngIf="isBanner">
        <div class="do-not-show-banner">
            <p>Click here if you do not want to see this page again.</p>
            <button mat-button class="primary">Don't Show This Again</button>
            <mat-icon class="close-icon" alt="Close dialog" (click)="closeBanner()">close</mat-icon>
        </div>
    </ng-container>
    <div class="success-banner">
        <div class="header-contents">
            <div class="primary-header">
                <h1>Getting Started</h1>
            </div>
            <!--Potential Future Addition-->
            <div class="not-ready-message">
                <p>The EZ DOCS getting started guide offers an overview and introduction to some of the application's key features.</p>
                <p>
                    If you want to explore on your own or start using the application right away, click any of the available functions on the navigation panel
                    or menu. You can return to this guide at any time from the Help Center. More detailed help and guidance is available within each function -
                    so you can always get the help you need when and where you need it.
                </p>
                <p>
                    We offer consulting sessions to maximize the benefits of EZ DOCS.
                    <b>
                        <a class="no-underline" href="https://outlook.office365.com/book/EZDOCSConsultation30Minutes@unitedigital.com/" target="_blank"
                            >Click here to schedule one</a
                        > </b
                    >.
                </p>
            </div>
            <!-- <div class="btn-wrap">
                <button class="skip-btn" (click)="goToLogin()">Continue</button>
            </div> -->
        </div>
    </div>
    <div class="admin-content">
        <div class="section-gray">
            <div class="success-container">
                <div class="left-content">
                    <h2>EZ DOCS Overview</h2>
                    <p>
                        EZ DOCS helps dealers optimize the car-buying process from initial customer contact to the signing of the final deal document and
                        beyond. The application's patented technology can be used to improve operations, enhance security and optimize the customer experience.
                        Features include scanning and validation of driver's licenses and other forms of identification, the collection of stips and other
                        documents from consumers, e-signing capabilities and more. Watch the video to learn more.
                    </p>
                </div>
                <div class="right-content">
                    <div (click)="openVideo('EZ Doc Overview', 'EzDocOverview.mp4')" class="image-wrap">
                        <!-- <img [src]="" class="screenshot" /> -->
                        <div class="image-overlay">
                            <mat-icon class="play-icon">play_circle_outline</mat-icon>
                        </div>
                        <video [src]="this.envVideoUrl + 'EzDocOverview.mp4' + '#t=5.1'"></video>
                    </div>
                </div>
            </div>
        </div>

        <div class="section">
            <div class="success-container">
                <div class="left-content">
                    <div (click)="openVideo('Leads Overview', 'E-SHOPLeadsOverview.mp4')" class="image-wrap">
                        <!-- <img [src]="" class="screenshot" /> -->
                        <div class="image-overlay">
                            <mat-icon class="play-icon">play_circle_outline</mat-icon>
                        </div>
                        <video [src]="this.envVideoUrl + 'E-SHOPLeadsOverview.mp4' + '#t=5.1'"></video>
                    </div>
                </div>
                <div class="right-content">
                    <h2>Leads</h2>
                    <p>
                        If an integration has been setup for your dealership, leads are fed into the application. Dealer users can view the lead details and
                        take various actions on each lead, including requesting and validating driver's licenses, requesting other documents (like proof of
                        insurance and bank statements) and creating Deal Jackets. Watch the video to learn more.
                    </p>
                    <div class="btn-wrap">
                        <button (click)="goToNewTab('leads')" class="see-video-btn">Go to Leads</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="section-gray">
            <div class="success-container">
                <div class="left-content">
                    <h2>Consumer Documents</h2>
                    <p>
                        With EZ DOCS you can quickly and securely collect driver's licenses and other documents from consumers who are still in the shopping
                        phase of their buying journey, whether they are remote or in-store. Driver's licenses and other forms of identification are scanned and
                        validated instantly, and the results are available within seconds so you can quickly detect fraud and prevent potential thefts. The
                        collected documents for each consumer are stored in a Document Jacket, which can be converted into a Deal Jacket once they have decided
                        to buy or lease a vehicle. Watch the video to learn more.
                    </p>
                    <div class="btn-wrap">
                        <button (click)="goToNewTab('documents')" class="see-video-btn">Go to Consumer Documents</button>
                    </div>
                </div>
                <div class="right-content">
                    <div (click)="openVideo('Consumer Documents Overview', 'ConsumerDocumentsOverview.mp4')" class="image-wrap">
                        <!-- <img [src]="" class="screenshot" /> -->
                        <div class="image-overlay">
                            <mat-icon class="play-icon">play_circle_outline</mat-icon>
                        </div>
                        <video [src]="this.envVideoUrl + 'ConsumerDocumentsOverview.mp4' + '#t=5.1'"></video>
                    </div>
                </div>
            </div>
        </div>

        <div class="section">
            <div class="success-container">
                <div class="left-content">
                    <div (click)="openVideo('User Management Overview', 'UserManagementOverview.mp4')" class="image-wrap">
                        <div class="image-overlay">
                            <mat-icon class="play-icon">play_circle_outline</mat-icon>
                        </div>
                        <video [src]="this.envVideoUrl + 'UserManagementOverview.mp4' + '#t=5.1'"></video>
                    </div>
                </div>
                <div class="right-content">
                    <h2>User Management</h2>
                    <p>
                        System Administrators and those with user management permissions for each dealership are responsible for adding and deleting dealer
                        users and managing their access to features and functions. Once a dealer user has been created, the user will receive a welcome email
                        with a link to complete their account set up. After they have completed their set up, they will be able to use the application based on
                        their defined permissions. Watch the video for a step-by-step demonstration of the process to add a new user.
                    </p>
                    <div class="btn-wrap">
                        <button (click)="goToNewTab('userManagement')" class="see-video-btn">Go to User Management</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="section-gray">
            <div class="success-container">
                <div class="left-content">
                    <h2>Dealer Management</h2>
                    <p>
                        Each enrolled dealership is set up in the application with default information, typically based on what an OEM provides. System
                        Administrators and those with dealer management permissions can update some of that information for use in the application, in addition
                        to adding a logo and specifying universal preferences. Watch the video for a step-by-step demonstration of this process.
                    </p>
                    <div class="btn-wrap">
                        <button (click)="goToNewTab('dealerManagement')" class="see-video-btn">Go to Dealer Management</button>
                    </div>
                </div>
                <div class="right-content">
                    <div (click)="openVideo('Dealer Management Overview', 'DealerManagementOverview.mp4')" class="image-wrap">
                        <div class="image-overlay">
                            <mat-icon class="play-icon">play_circle_outline</mat-icon>
                        </div>
                        <video [src]="this.envVideoUrl + 'DealerManagementOverview.mp4' + '#t=5.1'"></video>
                    </div>
                </div>
            </div>
        </div>

        <div class="section">
            <div class="centered-container">
                <h2>If you have any questions or need help, please reach out to us.</h2>
                <p>
                    Phone: <a [href]="'tel:+' + supportPhone">{{ supportPhone }}</a>
                </p>
                <p>
                    Email: <a [href]="'mailto:' + supportEmail">{{ supportEmail }}</a>
                </p>
            </div>
        </div>
    </div>
</div>
